import { useCallback, useMemo } from 'react';
import Link from '../../../../components/form/elements/link';
import { can, route } from '../../../../services/utils';
import { LIVESTOCK_ANIMALS_AND_EVENTS_INDEX } from '../../../../router/routes';
import Classifier from '../../../../enums/classifier';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/form/elements/button';
import { FormComponent } from '../../../../components/form';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import AnimalType from '../../../../enums/animal-type';

const ldcLoginUrl = 'https://info.ldc.gov.lv/login.php';
const transKeyPrefix = 'pages.livestock.animals_and_events.';

export const useCreateFooter = (eventType?: AnimalType) => {
  const { t } = useTranslation();

  const { farmId } = useParams<{
    farmId: string;
  }>();
  const tp = useCallback((key: string) => t(transKeyPrefix.concat(key)), [t]);
  const { farmUser } = useSelector((state: RootState) => ({
    farmUser: state.global.farmUser,
  }));

  const handleAnimalRegisterClick = useCallback(() => {
    window.open(ldcLoginUrl, '_blank', 'noopener,noreferrer');
  }, []);

  return useMemo<FormComponent[]>(
    () =>
      [
        can(farmUser, { title: 'create animal_event' })
          ? Button('continue', null, tp('events.grazing.create'))
          : null,
        eventType &&
        (eventType === AnimalType.seeding ||
          eventType === AnimalType.insemination)
          ? Button(
              'animal_register',
              handleAnimalRegisterClick,
              tp('events.grazing.animal_register'),
              null,
              null,
              true
            )
          : null,
        Link(
          route(LIVESTOCK_ANIMALS_AND_EVENTS_INDEX, {
            tab: Classifier.ANIMALS,
            farmId,
          }),
          'cancel'
        ),
      ].filter(Boolean),
    [handleAnimalRegisterClick, farmUser, farmId, tp, eventType]
  );
};
